export default "__VITE_ASSET__BfobB7X4__"